import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomButton from '../../components/common/CustomButton';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../../utils/constants';
import './AdditionalDetailsScreen.css';

const AdditionalDetailsScreen = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    gender: '',
    dateOfBirth: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleDateChange = (value) => {
    let formattedValue = value.replace(/\D/g, '');
    if (formattedValue.length > 2) {
      formattedValue = formattedValue.slice(0, 2) + '/' + formattedValue.slice(2);
    }
    if (formattedValue.length > 5) {
      formattedValue = formattedValue.slice(0, 5) + '/' + formattedValue.slice(5, 9);
    }
    handleInputChange('dateOfBirth', formattedValue);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateDateOfBirth = (dob) => {
    const dobRegex = /^(0[1-9]|1[0-9]|2[0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    return dobRegex.test(dob);
  };

  const handleSubmit = async () => {
    const { name, email, gender, dateOfBirth } = formData;

    if (!name) {
      toast.error('Please enter your full name.');
      return;
    }

    if (!email) {
      toast.error('Please enter your email.');
      return;
    }

    if (!validateEmail(email)) {
      toast.error('Invalid email address.');
      return;
    }

    if (!gender) {
      toast.error('Please select your gender.');
      return;
    }

    if (!dateOfBirth) {
      toast.error('Please enter your date of birth.');
      return;
    }

    if (!validateDateOfBirth(dateOfBirth)) {
      toast.error('Invalid date of birth. Use DD/MM/YYYY format.');
      return;
    }

    setLoading(true);

    try {
      const userToken = localStorage.getItem(AUTH_TOKEN_KEY);
      const response = await fetch(`${API_BASE_URL}api/doctor/profile/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`
        },
        body: JSON.stringify({
          name,
          gender,
          dateOfBirth,
          email
        }),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success(result.message);
        localStorage.setItem('USER_DETAILS', JSON.stringify(result.user));
        navigate('/dashboard');
      } else {
        toast.error(result.errorInfo || 'An error occurred.');
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.');
      console.error('Profile Update Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="additional-details-container">
      <div className="additional-details-card">
        <div className="additional-details-header">
          <h1>Complete Your Profile</h1>
          <p>Please provide your details to complete the registration</p>
        </div>

        <div className="additional-details-form">
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              maxLength={40}
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              maxLength={40}
            />
          </div>

          <div className="form-group">
            <label>Gender</label>
            <select
              value={formData.gender}
              onChange={(e) => handleInputChange('gender', e.target.value)}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label>Date of Birth</label>
            <input
              type="text"
              placeholder="DD/MM/YYYY"
              value={formData.dateOfBirth}
              onChange={(e) => handleDateChange(e.target.value)}
              maxLength={10}
            />
          </div>

          <CustomButton
            title={loading ? 'Updating...' : 'Continue'}
            onPress={handleSubmit}
            disabled={loading}
            size="large"
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalDetailsScreen;